// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","StrollerBoxWidget":"bee_a bhb_sl","StrollerBoxWidget__imageCounselling":"bee_b bhb_jz"};